import React from "react";
import { PageShell } from "../components/Layout";
import SeoContent from "../components/SeoContent";
import { api } from "../services/api";
import { ArrowRight, ArrowLeft, RefreshCw } from "lucide-react";
import useSeo from "../hooks/useSeo";

function Row({ label, letter, items, color, dir }) {
  const Arrow = dir === "left" ? ArrowLeft : ArrowRight;
  return (
    <div className="flex items-center gap-3 bg-white rounded-xl shadow-sm border border-gray-100 p-4">
      <div
        className="w-11 h-11 rounded-full flex items-center justify-center text-white font-black text-lg shrink-0"
        style={{ background: color }}
      >
        {letter}
      </div>
      <div className="flex items-center gap-1.5 text-gray-500 font-bold text-sm w-28 shrink-0">
        <Arrow className="w-4 h-4" /> {label}
      </div>
      <div className="flex flex-wrap gap-2">
        {items.map((n, i) => (
          <span
            key={i}
            className="min-w-[42px] text-center px-2.5 py-1.5 rounded-lg font-black text-white shadow-sm"
            style={{ background: color }}
          >
            {n}
          </span>
        ))}
      </div>
    </div>
  );
}

export default function PredictTarget() {
  const [p, setP] = React.useState({ direct: [], house: [], ending: [], date: "" });
  useSeo({
    title: "Sunday Ground Teer Predict Target | Direct, House & Ending",
    description:
      "Sunday Ground Teer Predict Target with today's Direct Number, House and Ending predictions, auto-updated daily from previous results. For reference only.",
  });

  React.useEffect(() => {
    api.predict().then(setP).catch(() => {});
  }, []);

  return (
    <>
      <PageShell title="Predict Target" subtitle="Direct • House • Ending — auto-updated daily">
        <p className="text-center text-xs text-gray-400 mb-5 flex items-center justify-center gap-1">
          <RefreshCw className="w-3 h-3" /> Auto changes daily • {p.date}
        </p>
        <div className="space-y-3 max-w-2xl mx-auto">
          <Row label="Direct Number" letter="D" items={p.direct} color="#e8491d" dir="right" />
          <Row label="House" letter="H" items={p.house} color="#f2a516" dir="left" />
          <Row label="Ending" letter="E" items={p.ending} color="#1aa79a" dir="left" />
        </div>
        <p className="text-center text-xs text-gray-400 mt-4">
          * Predict Target numbers auto-update every day based on previous results. For reference only.
        </p>
      </PageShell>
      <SeoContent variant="home" />
    </>
  );
}
